import { type as typeUtil } from '@mews/framework';
import ApiComponent from '../apiComponent';
import createRequest from './misc/createRequest';

const CARDS_URL = '/creditCards';

export default function CreditCardComponent(apiComponent: $TSFixMe) {
    typeUtil.check(apiComponent, ApiComponent);
    const cardsRequest = createRequest(apiComponent.request, CARDS_URL);

    return typeUtil.create(CreditCardComponent, {
        addCard({ customerId, expiration, format, holderName, nonce, obfuscatedNumber, type, enterpriseId }: $TSFixMe) {
            return cardsRequest('/add', {
                customerId,
                expiration,
                format,
                holderName,
                nonce,
                obfuscatedNumber,
                type,
                enterpriseId,
            });
        },
    });
}
